import React, { useState } from 'react';
import Box from "@mui/material/Box";

import {
    Container,
    Paper,
    Typography,
    TextField,
    Button,
    Grid,
    IconButton,
    Card,
    CardContent,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    CircularProgress,
    List,
    ListItem,
    ListItemText,
} from '@mui/material';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

import { Plus, Trash2 } from 'lucide-react';
import { Header } from '../Header';
import { local_url } from '../Const';
import { useNavigate } from 'react-router-dom';
import { ItemSelectionModal } from "./ItemSelectionModal";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from '@mui/material/InputAdornment';


export const CreateOrder = () => {
    const navigate = useNavigate();
    const [billingInfo, setBillingInfo] = useState({
        first_name: '',
        last_name: '',
        email: '',
        address: '',
        city: '',
        state: '',
        postcode: '',
        country: 'India',
        placeId: '',
        contact: '', // Added contact
        use_subscription: 0 // Added use_subscription
    });
    const [issueType, setIssueType] = useState("");
    const [linkedUsers, setLinkedUsers] = useState([]);
    const [isModalOpen, setIsModalOpen] = React.useState(false);

    const [searchError, setSearchError] = useState("");
    const [orderItems, setOrderItems] = useState([]);
    const [places, setPlaces] = useState([]);
    const [loadingPlaces, setLoadingPlaces] = useState(false);
    const [itemModalOpen, setItemModalOpen] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [headerInputs, setHeaderInputs] = useState({
        CustomerMobile: "",
        CustomerName: "",
        Pincode: "",
        CustomerCode: "",
        Amount: "",
    });
    // Handle pincode change and fetch places
    const handlePincodeChange = async (event) => {
        const pincode = event.target.value;
        setBillingInfo(prev => ({ ...prev, postcode: pincode }));

        if (pincode.length === 6) {
            setLoadingPlaces(true);
            try {
                const response = await fetch(`${local_url}/api/Place/${pincode}`);
                const data = await response.json();
                console.log('----', data);

                if (data.places) {
                    setPlaces(data.places);
                }
            } catch (error) {
                console.error('Error fetching places:', error);
            } finally {
                setLoadingPlaces(false);
            }
        } else {
            setPlaces([]);
        }
    };

    // Handle place selection and fetch place details
    const handlePlaceSelect = async (event) => {
        const placeId = event.target.value;
        setBillingInfo(prev => ({ ...prev, placeId }));

        try {
            const response = await fetch(`${local_url}/api/PlaceName/GetPlaceById/${placeId}`);
            const placeDataArray = await response.json();

            // Ensure the response is an array and has at least one item
            if (Array.isArray(placeDataArray) && placeDataArray.length > 0) {
                const placeData = placeDataArray[0]; // Get the first object from the array

                console.log('Parsed placeData:', placeData);

                setBillingInfo(prev => ({
                    ...prev,
                    city: placeData.cityName || '',
                    state: placeData.stateName || '',
                    country: placeData.countryCode === 'IN' ? 'India' : placeData.countryCode,
                    placeId: placeData.placeId
                }));
            } else {
                console.error('No place data found in response.');
            }
        } catch (error) {
            console.error('Error fetching place details:', error);
        }
    };


    const selectCustomer = (customer) => {
        // Set input fields (optional, if you want to pre-fill the form based on selection)
        setHeaderInputs({
            CustomerMobile: customer.mobile,
            CustomerName: customer.customerName,
            Mobile: customer.CustomerMobile,
            CustomerCode: customer.customerCode, // Assuming you have this field
            Amount: customer.amount, // Assuming amount is relevant
        });


        // Close the modal
        setModalOpen(false);
    };


    const performSearchByMobile = (mobile) => {
        const token = localStorage.getItem("AuthorizationToken");

        if (!token) {
            alert("Authorization token is missing. Please log in again.");
            localStorage.clear();
            sessionStorage.clear();
            window.location.href = "/login";
            return;
        }

        setIsSearching(true);
        setSearchError("");
        setLinkedUsers([]);

        fetch(`${local_url}/api/POSCustomerSerch/Get/${issueType}/MOBILE/${mobile}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) {
                        alert("Session expired. Please log in again.");
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = "/login";
                    } else {
                        throw new Error("Failed to fetch data.");
                    }
                }
                return response.json();
            })
            .then((data) => {
                if (data.customers && data.customers.length > 0) {
                    const mergedData = data.customers.map((customer) => {
                        const address =
                            data.custAddresses.find(
                                (addr) => addr.custID === customer.custID
                            ) || {};
                        return { ...customer, ...address };
                    });
                    setLinkedUsers(mergedData);
                    setIsModalOpen(true); // Open the modal
                } else {
                    setSearchError("No customers found for this mobile number.");
                }
            })
            .catch((error) => {
                console.error("Error:", error);
                setSearchError("Failed to fetch data. Please try again.");
            })
            .finally(() => {
                setIsSearching(false);
            });
    };


    const handleBillingChange = (field) => (event) => {
        setBillingInfo(prev => ({
            ...prev,
            [field]: event.target.value
        }));
    };

    // Rest of your existing handlers...
    const handleItemsSelected = (selectedItems) => {
        setOrderItems((prev) => {
            const newItems = selectedItems.filter(
                (selectedItem) => !prev.some((existingItem) => existingItem.itemId === selectedItem.itemID)
            ).map((item) => ({
                itemId: item.itemID,
                itemName: item.itemName,
                quantity: item.quantity || 1,
                partnumber: item.partnumber
            }));
            return [...prev, ...newItems];
        });
    };

    const removeOrderItem = (index) => {
        setOrderItems(prev => prev.filter((_, i) => i !== index));
    };

    const handleAddItems = () => {
        setItemModalOpen(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const payload = {
                contact: billingInfo.contact,
                use_subscription: billingInfo.use_subscription,
                order_items: orderItems.map(item => ({
                    product_id: item.itemId,
                    quantity: item.quantity
                })),
                billing: {
                    first_name: billingInfo.first_name,
                    last_name: billingInfo.last_name,
                    email: billingInfo.email,
                    address: billingInfo.address,
                    city: billingInfo.city,
                    state: billingInfo.state,
                    postcode: billingInfo.postcode,
                    country: billingInfo.country
                }
            };

            const response = await fetch(`https://demo14.1hour.in/wp-json/order/v1/create`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                navigate('/alloted-orders');
            } else {
                console.error('Failed to create order');
            }
        } catch (error) {
            console.error('Error creating order:', error);
        }
    };


    return (
        <Container>
            <Header />
            <Paper component="form" onSubmit={handleSubmit} sx={{ mt: 4, p: 4 }}>
                <Typography variant="h5" gutterBottom>
                    Create New Order
                </Typography>

                <Card sx={{ mb: 4 }}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            Billing Information
                        </Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    required
                                    fullWidth
                                    label="First Name"
                                    value={billingInfo.first_name}
                                    onChange={handleBillingChange('first_name')}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    required
                                    fullWidth
                                    label="Last Name"
                                    value={billingInfo.last_name}
                                    onChange={handleBillingChange('last_name')}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    required
                                    fullWidth
                                    label="Mobile Number"
                                    variant="outlined"
                                    value={billingInfo.contact}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*$/.test(value) && value.length <= 10) {
                                            handleBillingChange('contact')(e); // Update billing info state
                                        }
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => performSearchByMobile(billingInfo.contact)}
                                                    edge="end"
                                                    disabled={billingInfo.contact.length === 0 || isSearching}
                                                >
                                                    {isSearching ? <CircularProgress size={24} /> : <SearchIcon />}
                                                </IconButton>
                                            </InputAdornment>

                                        ),
                                    }}
                                    inputProps={{
                                        maxLength: 10,
                                        pattern: "[0-9]*",
                                    }}
                                    sx={{ mb: 2 }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel>Use Subscription Points</InputLabel>
                                    <Select
                                        value={billingInfo.use_subscription}
                                        onChange={handleBillingChange('use_subscription')}
                                        label="Use Subscription Points"
                                    >
                                        <MenuItem value={0}>No</MenuItem>
                                        <MenuItem value={1}>Yes</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    type="email"
                                    label="Email"
                                    value={billingInfo.email}
                                    onChange={handleBillingChange('email')}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    label="Address"
                                    value={billingInfo.address}
                                    onChange={handleBillingChange('address')}
                                    multiline
                                    rows={2}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    required
                                    fullWidth
                                    label="Pincode"
                                    value={billingInfo.postcode}
                                    onChange={handlePincodeChange}
                                    inputProps={{ maxLength: 6 }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel>Place</InputLabel>
                                    <Select
                                        value={billingInfo.placeId}
                                        onChange={handlePlaceSelect}
                                        label="Place"
                                        disabled={loadingPlaces || places.length === 0}
                                    >
                                        {loadingPlaces ? (
                                            <MenuItem disabled>
                                                <CircularProgress size={20} />
                                            </MenuItem>
                                        ) : (
                                            places.map((place) => (
                                                <MenuItem key={place.placeId} value={place.placeId}>
                                                    {place.placeName}
                                                </MenuItem>
                                            ))
                                        )}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    required
                                    fullWidth
                                    label="City"
                                    value={billingInfo.city}
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    required
                                    fullWidth
                                    label="State"
                                    value={billingInfo.state}
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    required
                                    fullWidth
                                    label="Country"
                                    value={billingInfo.country}
                                    disabled
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

                {/* Order Items Section */}
                <Card>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            Order Items
                        </Typography>
                        {orderItems.length === 0 ? (
                            <Typography color="textSecondary" sx={{ my: 2 }}>
                                No items added. Click "Add Item" to select items.
                            </Typography>
                        ) : (
                            orderItems.map((item, index) => (
                                <Grid container spacing={2} key={index} sx={{ mb: 2 }}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            disabled
                                            fullWidth
                                            label="Item Name"
                                            value={item.itemName}
                                            helperText={`Part Number: ${item.partnumber || 'N/A'}`}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            required
                                            fullWidth
                                            type="number"
                                            label="Quantity"
                                            value={item.quantity}
                                            onChange={(e) => {
                                                const newItems = [...orderItems];
                                                newItems[index].quantity = e.target.value;
                                                setOrderItems(newItems);
                                            }}
                                            inputProps={{ min: 1 }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <IconButton
                                            color="error"
                                            onClick={() => removeOrderItem(index)}
                                        >
                                            <Trash2 />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            ))
                        )}

                        <Button
                            startIcon={<Plus />}
                            onClick={handleAddItems}
                            variant="outlined"
                            sx={{ mt: 2 }}
                        >
                            Add Item
                        </Button>
                    </CardContent>
                </Card>

                <ItemSelectionModal
                    open={itemModalOpen}
                    onClose={() => setItemModalOpen(false)}
                    onItemSelect={handleItemsSelected}
                    existingItems={orderItems}
                />

                <Grid container spacing={2} sx={{ mt: 4 }}>
                    <Grid item>
                        <Button
                            variant="outlined"
                            onClick={() => navigate('/alloted-orders')}
                        >
                            Cancel
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={orderItems.length === 0}
                        >
                            Create Order
                        </Button>
                    </Grid>
                </Grid>

                <Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)} fullWidth maxWidth="md">
                    <DialogTitle>Search Results</DialogTitle>
                    <DialogContent>
                        {searchError && (
                            <Typography color="error" sx={{ mb: 2 }}>
                                {searchError}
                            </Typography>
                        )}
                        {isSearching ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                                <CircularProgress />
                            </Box>
                        ) : linkedUsers.length > 0 ? (
                            <List>
                                {linkedUsers.map((user, index) => (
                                    <ListItem key={index} button onClick={() => selectCustomer(user)} divider>
                                        <ListItemText
                                            primary={`Customer: ${user.customerName} (${user.custID})`}
                                            secondary={`Mobile: ${user.mobile}, Branch ID: ${user.branchID}, City ID: ${user.cityId}, Pincode: ${user.pincode}, Address: ${user.customerAddress || 'N/A'}`}
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        ) : (
                            <Typography>No customers found.</Typography>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setIsModalOpen(false)}>Close</Button>
                    </DialogActions>
                </Dialog>

            </Paper>
        </Container>
    );
};

export default CreateOrder;